import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { app_url } from "../../../../config";
import Error500 from "../../../../components/500/Error500";

const AddPlanPage = () => {
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("adminEtijwaal"))?.token;
  const [loading, setLoading] = useState(false);
  const [networkIssue, setNetworkIssue] = useState(false);
  const [failed, setFailed] = useState("");
  const [planData, setPlanData] = useState({
    plan_name: "",
    discount_percentage: "",
    selling_margin_percentage: "",
    description: null,
  });

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setPlanData((prev) => ({
      ...prev,
      [name]: type === "number" ? parseFloat(value) : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(`${app_url}/api/partner/addPartnerPlan`, planData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          toast.success(res.data.message || "Plan Created Successfully");
          navigate("/partners/partner-plan");
        } else {
          toast.error(res.data.message || "Failed to create plan");
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          if (err.response.status === 400) {
            toast.error(err.response.data.message || "Bad Request");
          } else if (err.response.status === 401) {
            navigate("/");
          } else if (err.response.status === 500) {
            toast.error(err.response.data.message || "Internal Server Error");
          } else {
            toast.error("An unexpected error occurred.");
          }
        } else {
          setNetworkIssue(true);
          toast.error("Network error. Please check your internet connection.");
          setFailed("Network error. Please check your internet connection.");
        }
      });
  };

  if (networkIssue) {
    return <Error500 message={failed} />;
  }

  return (
    <section className="wrapper">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <p className="heading mb-0">
          <i
            className="bi bi-arrow-left-circle-fill fs-3 me-3 my-auto pointer"
            onClick={() => window.history.back()}
          ></i>
          Create New Plan
        </p>
      </div>

      <div className="card border-0 shadow-sm">
        <div className="card-body p-4">
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="planName" className="form-label fw-semibold">
                    Plan Name
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    id="planName"
                    name="plan_name"
                    value={planData.plan_name}
                    onChange={handleChange}
                    placeholder="e.g., Premium Business Plan"
                    required
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="discountPercentage"
                    className="form-label fw-semibold"
                  >
                    Discount Offered to Partner (%)
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">%</span>
                    <input
                      type="number"
                      className="form-control form-control-lg"
                      id="discountPercentage"
                      name="discount_percentage"
                      value={planData.discount_percentage}
                      onChange={handleChange}
                      min="0"
                      max="99.99"
                      step="0.01"
                      placeholder="0.00"
                      required
                    />
                  </div>
                  {/* Discount Note */}
                  <div className="form-text text-muted small mt-1">
                    Note: Percentage discount applied to the base package price
                    for this partner.
                  </div>
                </div>
              </div>
            </div>

            <div className="row g-3">
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    htmlFor="sellingMarginPercentage"
                    className="form-label fw-semibold"
                  >
                    Profit Margin (on Discounted Price)
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">%</span>
                    <input
                      type="number"
                      className="form-control form-control-lg"
                      id="sellingMarginPercentage"
                      name="selling_margin_percentage"
                      value={planData.selling_margin_percentage}
                      onChange={handleChange}
                      min="0"
                      max="99.99"
                      step="0.01"
                      placeholder="0.00"
                      required
                    />
                  </div>
                  {/* Selling Margin Note */}
                  <div className="form-text text-muted small mt-1">
                    Note: Profit margin applied after the partner discount — not
                    on the base price.
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-3">
              <label
                htmlFor="planDescription"
                className="form-label fw-semibold"
              >
                Description
              </label>
              <textarea
                className="form-control form-control-lg"
                id="planDescription"
                name="description"
                value={planData.description}
                onChange={handleChange}
                rows="3"
                placeholder="Brief description of the plan"
              ></textarea>
            </div>

            <div className="d-flex gap-3">
              <button
                type="submit"
                className="btn btn-primary btn-lg"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Creating...
                  </>
                ) : (
                  "Create"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default AddPlanPage;
